import React from "react";
import PropTypes from "prop-types";

const InputCheckboxComponent = ({
  label,
  name,
  onChange,
  checked = false,
  hidden = false,
  disabled = false,
  style = "",
  input_style = "",
  display = "flex",
}) => {
  if (hidden) return null; // If hidden is true, skip rendering the checkbox

  return (
    <div className={`checkbox-wrapper ${style}`} >
      <label className={`checkbox-container`}>
        <input
          id={name}
          type="checkbox"
          className={input_style}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          aria-label={label}
        />
        <span className="custom-checkbox"></span>
        {label}
      </label>
    </div>
  );
};

InputCheckboxComponent.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.string,
  inputStyle: PropTypes.string,
  display: PropTypes.bool,
};

export default InputCheckboxComponent;
